<template>
    <v-container fluid>
     <v-row
        align="center"
        justify="center"
        class="mx-0"
      >
       <v-col cols="12" md="6">
          <v-card outlined height="250">
            <v-card-text>
              <div class="text-center text-subtitle-1">You are currently subscribed to the</div>
              <div class="text-h5 text-center my-2">
                {{ planName }}
              </div>
              <div class="text-center text-subtitle-1">For <span class="font-weight-bold">{{ businessProfile.noOfEmployees || 0 }}</span> Team Members</div>
              <div class="text-center text-subtitle-1"><span class="font-weight-bold">{{ noOfCardHolders || 0 }} of {{ businessProfile.noOfEmployees || 0 }}</span> Cards Currently Deployed</div>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
                <v-btn elevation="0" to="/manageSubscription" class="primary" large width="250">Manage Subscription</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
       </v-col>
       <v-col cols="12" md="6">
          <v-card outlined height="250">
            <v-card-text>
                <div class="text-center text-subtitle-1">Next Charge</div>
                <div class="text-h5 text-center my-2">$ {{ businessProfile.nextInvoiceAmount/100 }} <sup><span class="text-caption">AUD</span></sup></div>
                <div class="text-center text-subtitle-1">On <span class="font-weight-bold">{{ formatDate(businessProfile.nextInvoiceCreationDate.toDate()) }}</span></div>
                <div class="text-center text-subtitle-1" v-if="businessProfile.lastFour != undefined && businessProfile.lastFour != ''">You have one saved credit card ending <span class="font-weight-bold">{{ businessProfile.lastFour }}</span></div>
                <div class="text-center text-subtitle-1" v-else>You have no saved payment method<span class="font-weight-bold">{{ businessProfile.lastFour }}</span></div>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
                <v-btn elevation="0" to="/manageBilling" class="primary" large width="250">Manage Billing</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
       </v-col>
     </v-row>
    </v-container>
</template>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import 'firebase/functions'
import Utility from '@/shared/utility'

export default {
  name: 'Subscription',
  created() {
    this.formatDate = Utility.formatDate;
    this.getSubscriptionPlanTitle = Utility.getSubscriptionPlanTitle;
  },    
  computed: {
    ...mapGetters(['businessProfile', 'noOfCardHolders']),
    planName() {
          return this.getSubscriptionPlanTitle(this.businessProfile.plan);
      },
  }
}
</script>
